import { LOGO_URL } from "@/lib/api";

/**
 * size: "sm" | "md" | "lg" | "xl"
 * variant: "dark" (logo couleur sur fond clair) | "light" (logo dans badge blanc sur fond sombre)
 */
export const Logo = ({ size = "md", variant = "dark", showLabel = true, invert = false }) => {
  const sizes = {
    sm: { img: "h-10 w-10", title: "text-lg", label: "0.55rem", pad: "p-1.5" },
    md: { img: "h-14 w-14", title: "text-2xl", label: "0.6rem", pad: "p-1.5" },
    lg: { img: "h-20 w-20", title: "text-3xl", label: "0.65rem", pad: "p-2" },
    xl: { img: "h-28 w-28", title: "text-4xl", label: "0.7rem", pad: "p-2.5" },
  };
  const s = sizes[size] || sizes.md;

  // invert prop kept for backwards compat
  const isLight = invert || variant === "light";

  const imgEl = (
    <img
      src={LOGO_URL}
      alt="WebUP — Agence digitale Tarn"
      className={`${s.img} object-contain shrink-0`}
    />
  );

  return (
    <div className={`flex items-center gap-3 ${isLight ? "text-white" : "text-ink"}`}>
      {isLight ? (
        // On dark background: put logo inside a white card so original colors show
        <span className={`inline-flex items-center justify-center bg-white ${s.pad} shadow-[0_8px_20px_-10px_rgba(0,0,0,0.4)]`}>
          {imgEl}
        </span>
      ) : (
        imgEl
      )}
      {showLabel && (
        <div className="flex flex-col leading-none">
          <span className={`font-display ${s.title} tracking-tight`}>webup</span>
          <span className="font-mono-label opacity-70" style={{ fontSize: s.label }}>
            AGENCE DIGITALE
          </span>
        </div>
      )}
    </div>
  );
};
